export default __webpack_public_path__ + "static/media/Evapotranspiration.e2ad8d67.webp";